import { Grid, Typography } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import SupplierControlService from "./SupplierControlService";
import DefaultChip from "../../componentes/chip/DefaultChip";
/**
 * Author : AndréK
 * 26/08/2022
*/

export const SupplierAddress = ({ idSupplier }) => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        idSupplier: idSupplier,
        address: "",
        number: "",
        complement: "",
        neighborhood: "",
        cep: "",
        idCountry: 1,
        idState: 0,
        idCity: 0,
        rows: [],
        loggedUserId: userId,
        status: 1,
        success: false,
        error: false,
    };

    function formatCEP(value) {
        value = value.replace(/\D/g, ''); // Remove tudo que não é número

        if (value.length > 2) {
            value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        }
        if (value.length > 6) {
            value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2-$3');
        }

        return value.slice(0, 10); // Limita a 10 caracteres (12.345-678)
    }


    const columns = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "address",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} name="address" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.address}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "number",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="number" name="qtty" />;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.number}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "neighborhood",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="neighborhood" name="address" />;
        },
    },
    {
        field: "cep",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="cep" name="cep"/>;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{formatCEP(props.cep)}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status == 1 ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];



    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [SupplierAddress, dispatch] = useReducer(reducer, initialState);

    const { id, address, number, complement, neighborhood, cep, idCity, status } = SupplierAddress
    const { idCountry, idState, success, error, rows, ...data } = SupplierAddress

    const handleChange = ({ target: { name, value } }) => {
        if (name === "idState") {
            dispatch({ type: 'update', data: { [name]: value, idCity: 0 } })
        }
        else if (name === "idCountry") {
            dispatch({ type: 'update', data: { [name]: value, idState: 0, idCity: 0 } })
        }
        else if (name === "cep") {
            const formattedCep = formatCEP(value);
            dispatch({ type: 'update', data: { [name]: value, cep: formattedCep } })
        }
        else { dispatch({ type: 'update', data: { [name]: value } }) }
    }

    const handleSearch = () => {
        SupplierControlService
            .getSupplierAddress(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }

    const canSave = () => address !== "";

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                SupplierControlService
                    .updateSupplierAddress(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                SupplierControlService
                    .createSupplierAddress(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'update', data: { success: true, error: false, id: response.data.id } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }
    }

    const handleCellClick = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                address: data.address,
                number: data.number,
                complement: data.complement,
                neighborhood: data.neighborhood,
                cep: data.cep,
                idCountry: data.idCountry,
                idState: data.idState,
                idCity: data.idCity,
                status: data.status,
            }
        })
    }

    useEffect(() => {
        handleSearch();
    }, [])


    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    <GridInputRow>
                        <Grid item xs={12} sm={6} md={3}>
                            <DefaultAutocomplete
                                name={"idCountry"}
                                onChange={handleChange}
                                placeholder={t("country")}
                                label={t("country")}
                                useApi
                                endpoint='GetCountryAutocomplete'
                                value={idCountry}
                                defaultSize
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DefaultAutocomplete
                                name={"idState"}
                                onChange={handleChange}
                                placeholder={t("state")}
                                label={t("state")}
                                useApi
                                endpoint='GetStateAutocomplete'
                                contextKey={idCountry}
                                value={idState}
                                disabled={idCountry === 0}
                                defaultSize
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DefaultAutocomplete
                                name={"idCity"}
                                onChange={handleChange}
                                placeholder={t("city")}
                                label={t("city")}
                                useApi
                                endpoint='GetCityAutocomplete'
                                contextKey={idState}
                                value={idCity}
                                disabled={idState === 0}
                                defaultSize
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="cep" labelName="cep" />
                                }
                                name="cep"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={cep}
                                inputProps={{ maxLength: 20 }}
                                error={error && cep === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="address" labelName="address" />
                                }
                                name="address"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={address}
                                inputProps={{ maxLength: 150 }}
                                error={error && address === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="qtty" labelName="number" />
                                }
                                name="number"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={number}
                                inputProps={{ maxLength: 20 }}
                                error={error && number === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="address" labelName="neighborhood" />
                                }
                                name="neighborhood"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={neighborhood}
                                inputProps={{ maxLength: 150 }}
                                error={error && neighborhood === ""}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <DefaultAutocomplete
                                name={"status"}
                                onChange={handleChange}
                                value={status}
                                label={t("status")}
                                defaultSize
                                items={[
                                    { id: 0, name: t("canceled"), status: 1 },
                                    {id: 1, name: t("active"), status: 1},
                                    {id: 2, name: t("all"), status: 1},
                                ]}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <InputField
                                iconLabelSwitch={
                                    <IconLabelSwitch name="address" labelName="complement" />
                                }
                                name="complement"
                                control={control}
                                defaultValue=""
                                onChange={handleChange}
                                value={complement}
                                inputProps={{maxLength: 150}}
                            />
                        </Grid>
                    </GridInputRow>
                    <SearchClearSaveRow
                        onClickSearch={handleSearch}
                        onClickClear={() => dispatch({ type: 'clear' })}
                        onClickSave={handleSaveUpdate}
                    />
                    {(rows.length > 0) ? (
                        <GridInputRow>
                            <Grid item xs={12}>
                                <DefaultDatagrid
                                    columns={columns(t)}
                                    dataSource={rows}
                                    allowPaging={true}
                                    cellSelected={(args, grid) =>
                                        handleCellClick(args.data)
                                    } />
                            </Grid>
                        </GridInputRow>
                    ) : null}
                </GridItemContainer>
            } />
    );
}